import React, { useEffect, useState } from "react";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import axios from "../../../axios-instance";
import { toast } from "react-toastify";
import queryString from "query-string";
import Select from "react-select";

import Container from "../../../components/UI/Container/Container";
import OpenEnvelope from "../../../images/open-envelope.png";
import EmailSent from "../../../images/email-sent.png";

import { InputValidation } from "../../../components/UI/InputValidation/InputValidation";
import { isValidEmail } from "../../../helpers/validators";

import "./SeasonPassMember.sass";
import { seasonPassMemberLangs } from "../../../constants/seasonPassMemberLangs";
import ROUTES from "../../../constants/routes";
import NewLoader from "../../../components/NewLoader/NewLoader";
import { getLangCode, languagesList, setLangCode } from "../../../constants/seasonPassPersonalInfoLangs";

export const SeasonPassMember = ({ match, history, ...params }) => {
  const [isEmailSent, setIsEmailSent] = useState(false);
  const [email, setEmail] = useState("");
  const [validEmail, setValidEmail] = useState(true);
  const [promoterPrefix, setPromoterPrefix] = useState("partizan");
  const [isLoading, setLoading] = useState(false);
  const [lang, setLang] = useState(queryString.parse(params.location.search).lang || getLangCode());

  const isAcceptableEmail = () => isValidEmail(email);

  const handleLang = (lang) => {
      const acceptedLangs = ['en', 'rs'];
      if (!lang || !getLangCode() || !acceptedLangs.some((key) => key == lang)) {
          setLangCode('rs');
          return;
      }

      setLangCode(lang);
  };

  const handleChangeLang = (lang) => {
    setLang(lang.value);
    setLangCode(lang.value);

    const queryParams = new URLSearchParams(window.location.search);

    queryParams.set('lang', lang.value);
    window.history.replaceState(null, null, "?" + queryParams.toString());
  }

  const lostFocusEmailInput = () => {
    const valid = isAcceptableEmail();

    if (!!email) {
      setValidEmail(valid);
    }
  };

  const changeInputEmailHandler = (e) => {
    setEmail(e.target.value.trim());
    setValidEmail(true);
  };

  const changeEmailHandler = (e) => {
    setIsEmailSent(false);
  };

  const confirmEmailHandler = (e) => {
    const query = queryString.stringify({ email }, { encode: false });
    const token = localStorage.getItem('user_' + email.toLowerCase().trim());
    setLoading(true);

    if (token)
    {
      axios
      .get(`/SeasonPassMember?accessToken=${token}`)
      .then((response) => {
        if (response.status === 200 && response.data) {
          window.open(ROUTES.MEMBER + `?token=${token}&lang=${lang}`, "_blank");
          return;
        }

        localStorage.removeItem('user_' + email.toLowerCase().trim());
      })
      .catch((err) => {
        localStorage.removeItem('user_' + email.toLowerCase().trim());
        toast.error("Something went wrong");
      })
      .finally(() => {
        setLoading(false);
      });
    }
    else
    {
      axios
      .post(`/SeasonPassMember/request-to-login?${query}&lang=${lang}&promoterPrefix=${promoterPrefix}`)
      .then((response) => {
        if (response.status === 200) {
          setIsEmailSent(true);

          toast.success('Email sent successfully. Please check your mailbox.');
          return;
        }
        else  {
          window.open(`https://sso.partizan.basketball/register?returnTo=https://partizan.basketball/tickets`, "_blank");
          return;
        }

        throw new Error(response.data.errorMessage);
      })
      .catch((err) => {
        window.open(`https://sso.partizan.basketball/register?returnTo=https://partizan.basketball/tickets`, "_blank");
        toast.error("Something went wrong");
      })
      .finally(() => {
        setLoading(false);
      });
    }
  };

  useEffect(() => {
    handleLang(lang);
  }, []);

  const { emailSent, emailConfirmation } = seasonPassMemberLangs[lang];

  return (
    <Container className="seasonpass seasonpass-member">
      {isEmailSent ? (
        <div className="seasonpass-member__block">
          <Select
            options={languagesList}
            name="language"
            value={languagesList.find(({ value }) => lang === value)}
            onChange={handleChangeLang}
            classNamePrefix="partizan-open-selling__select"
            className="partizan-open-selling__select partizan-open-selling__select--lang"
          />
          <img style={{width: 120 }} src={EmailSent} alt="open envelope" />
          <h2 className="title">{emailSent.title}</h2>
          <span className="about">{emailSent.about}</span>
          <div className="seasonpass-member__actions">
            <button
              className="btn-primary white-button"
              onClick={changeEmailHandler}
            >
              {emailSent.btnChange}
            </button>
            {isLoading ? (
              <div className="seasonpass-member__loader">
                <NewLoader />
              </div>
            ) : (
              <button className="btn-primary" onClick={confirmEmailHandler}>
                {emailSent.btnReset}
              </button>
            )}
          </div>
        </div>
      ) : (
        <div className="seasonpass-member__block">
          <Select
            options={languagesList}
            name="language"
            value={languagesList.find(({ value }) => lang === value)}
            onChange={handleChangeLang}
            classNamePrefix="partizan-open-selling__select"
            className="partizan-open-selling__select partizan-open-selling__select--register-lang"
          />

          <img style={{width: 120 }} src={OpenEnvelope} alt="open envelope" />
          <h2 className="title">{emailConfirmation.title}</h2>
          <span className="about">{emailConfirmation.about}</span>

          <InputValidation
            value={email}
            placeholder={emailConfirmation.inputEmailPlaceholder}
            isValid={validEmail}
            errorMessage={emailConfirmation.inputEmailErrorMessage}
            className="input-email"
            onChange={changeInputEmailHandler}
            onBlur={lostFocusEmailInput}
            disabled={isLoading}
          />
          <p className="seasonpass-member__note">{emailConfirmation.infoText}</p>
          <div className="seasonpass-member__actions">
            {isLoading ? (
              <div className="seasonpass-member__loader">
                <NewLoader />
              </div>
            ) : (
              <button
                disabled={!validEmail || !email}
                onClick={confirmEmailHandler}
                className="btn-primary"
              >
                {emailConfirmation.btnConfirm}
              </button>
            )}
          </div>
        </div>
      )}
    </Container>
  );
};

const mapStateToProps = () => {};
const mapDispatchToProps = (dispatch) => {};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SeasonPassMember)
);
